import React from 'react';

import GameContext from 'Containers/GameContext';
import GameTopic from 'Components/GameTopic';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './GameTopics.scss';

const GameTopics = ({ slug, topics }) => {
  if (topics.length === 0) return null;
  return (
    <div id="topics" className={`GameTopics GameTopics--${slug}`}>
      <div className="GameTopics__container">
        <header className="GameTopics__header">
          <h4 className="GameTopics__header-title">
            <ConnectedFormattedMessage id="game_topics.title" />
          </h4>
        </header>
        <div className="GameTopics__items">
          {topics.map((topic, i) => (
            <GameTopic
              key={`topic-${slug}-${i}`}
              gameSlug={slug}
              index={i}
              id={topic}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameContext(GameTopics);
